import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { RiRefreshLine } from "react-icons/ri";
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import PersonalDetails from './personalDetails';
import ContactDetails from './contactDetails';
import DocumentDetails from './documentDetails';
import Activity from './activity';
import GLAccount from './GLAccounts';
import PreferenceDetails from './preference';
import { getCountryFromCurrency } from '../../../INVENTORY/Layouts/currencyHelpers';
const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL


const CustomerMaster = () => {
    const apiService = new LeaseApiService();
    let navigate = useNavigate()
    const { currencyPrecision } = useCurrency();
    const currencyList = JSON.parse(localStorage.getItem('currencylist')) || [];
    const defaultCountry = currencyPrecision?.code ? getCountryFromCurrency(currencyPrecision?.code, currencyList) : 'bh'; // fallback until API loads
    const [activeFY, setActiveFY] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false, false, false, false, false]);
    const [loading, setloader] = useState(false)
    const [contactList, setContactList] = useState([])
    const [documentsList, setDocumentsList] = useState([])
    const [activityList, setActivityList] = useState([])
    const [preferenceList, setPreferenceList] = useState([])

    const [gLAccounts, setGLAccounts] = useState({
        subgroup: null,
        accountcode: null,
        accountname: null,
        createledger: false,
        sgAccount: null,
    });
    useEffect(() => {
        const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
        const activeFinancialYear = financialYears?.find(fy => fy.isActive);
        if (activeFinancialYear) {
            setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
        }
    }, []);
    const [transectionData, setTransectionData] = useState({
        rentPerPeriod: '',
        securityDeposit: '',
        rentperStayedPeriod: '',
        totalDeduction: '',
        totalAmountRec: '',
        sdRefund: '',
        rentAmtBalance: '',
        totalReceiveable: '',
        vacatingReason: '',
        remarks: '',
        rentBalance: '',
        stayedRent: '',
        deductionTotal: '',
        calculatedDays: '',
        totalpayable: '',
        rentPeriodUnchange: '',
        countryCode: '',
    });
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handleBackClick = () => {
        window.history.back();
    }
    return (
        <div className='p-5'>
            {/* Filters */}
            <div className='border-box2 p-2 d-flex gap-3 end' style={{ borderRadius: "8px" }}>

                {loading === true ?
                    <div className='mainbtn flex-end gap-2'>
                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                    </div>
                    :
                    <div className='mainbtn flex-end gap-2'>
                        <FaSave color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Save</div>
                    </div>
                }
                <div className='mainbtnSecondary flex-end gap-2' onClick={handleBackClick}>
                    <FaChevronLeft color='#fff' className='center mt-1 mx-2' />
                    <div className='center'>Back</div>
                </div>
            </div>
            <div className="border-box2 my-3 p-3" style={{ borderRadius: "8px" }}>
                <div className='nav nav-pills overslid d-flex gap-4'>
                    <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}>Personal Details
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)}>Additional Contact
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(2)} >Documents Details
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 3 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(3)} >Activity
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 4 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(4)} >GL Account
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 5 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(5)} >Preference
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 6 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(6)} >History
                    </div>
                </div>
            </div>
            {/* Lease Details */}
            {gridVisibility[0] && (<PersonalDetails setTransectionData={setTransectionData} transectionData={transectionData} defaultCountry={defaultCountry} />)}
            {gridVisibility[1] && (<ContactDetails setContactList={setContactList} contactList={contactList} currencyPrecision={currencyPrecision} defaultCountry={defaultCountry} />)}
            {gridVisibility[2] && (<DocumentDetails setDocumentsList={setDocumentsList} documentsList={documentsList} />)}
            {gridVisibility[3] && (<Activity setActivityList={setActivityList} activityList={activityList} />)}
            {gridVisibility[4] && (<GLAccount setGLAccounts={setGLAccounts} gLAccounts={gLAccounts} />)}
            {gridVisibility[5] && (<PreferenceDetails setPreferenceList={setPreferenceList} preferenceList={preferenceList} />)}
        </div>

    );
};
export default CustomerMaster;